// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    REFRESH: '/api/refresh',
    USER: '/api/user',
    REGISTER: '/api/register'
  },
  AD_ACCOUNTS: {
    LIST: '/api/v1/ad-accounts',
    LIST_FOR_SCOPE: '/api/v1/ad-accounts/list-for-scope',
    EXPORT: '/api/v1/ad-accounts/export',
    HIDE: '/api/v1/ad-accounts/hide',
    UPDATE_LONG_ID: '/api/v1/ad-accounts',
    INSIGHTS: '/api/v1/ad-accounts/insights',
    CHECK_NOT_IN_SYSTEM: '/api/v1/ad-accounts/check-not-in-system',
    VIAS: '/api/v1/ad-accounts',
    RENTAL_SPENDING: '/api/v1/ad-accounts/rental-spending-list',
    RENTAL_SPENDING_TOTALS: '/api/v1/ad-accounts/rental-spending-list/totals',
    RENTAL_SPENDING_EXPORT: '/api/v1/ad-accounts/rental-spending-list/export',
    RENTAL_SPENDING_EXPORT_INIT: '/api/v1/rental-spending/export/init',
    RENTAL_SPENDING_EXPORT_APPEND: '/api/v1/ad-accounts/rental-spending-list/export/append'
  },
  VIA_FACEBOOK: {
    LIST: '/api/via-facebook',
    CREATE: '/api/via-facebook',
    UPDATE: '/api/via-facebook',
    DELETE: '/api/via-facebook',
    EXPORT: '/api/via-facebook/export',
    CHECK_TOKEN: '/api/via-facebook',
    SYNC_AD_ACCOUNTS: '/api/via-facebook/via-ad-accounts', // TODO: update URL
    SYNC_BM_ACCOUNTS: '/api/via-facebook/bms', // TODO: update URL
    SYNC_PAGES: '/api/via-facebook/pages' // TODO: update URL
  },
  EXCEL_SHEETS: {
    LIST: '/api/v1/excel-sheets',
    CREATE: '/api/v1/excel-sheets',
    UPDATE: '/api/v1/excel-sheets',
    DELETE: '/api/v1/excel-sheets',
    ACTIVE_WITH_MONTH: '/api/v1/excel-sheets/active-with-month'
  },
  FACEBOOK_OAUTH: {
    OAUTH_CONFIG: '/api/facebook/oauth-config',
    EXCHANGE_TOKEN: '/api/facebook/exchange-token'
  },
  BILLING: {
    LIST: '/api/v1/billing-history',
    EXPORT: '/api/v1/billing-history/export',
    ACCOUNTS: '/api/v1/accounts'
  },
  NOTIFICATIONS: {
    UNREAD_COUNT: '/api/notifications/unread-count',
    LIST: '/api/notifications',
    READ: (id) => `/api/notifications/${id}/read`
  },
  USERS: {
    LIST: '/api/users',
    CREATE: '/api/users',
    UPDATE: '/api/users',
    DELETE: '/api/users',
    WITH_ROLES: '/api/users/with-roles',
    ENSURE_SHIELD_CONFIG_ACCESS: '/api/users/ensure-shield-config-access'
  },
  ROLES: {
    LIST: '/api/roles',
    CREATE: '/api/roles',
    UPDATE: '/api/roles',
    DELETE: '/api/roles',
    PERMISSIONS: '/api/permissions'
  },
  TELEGRAM_COMPANIES: {
    LIST: '/api/v1/telegram-companies',
    CREATE: '/api/v1/telegram-companies',
    STORE: '/api/v1/telegram-companies/store',
    EXPORT: '/api/v1/telegram-companies/export',
    USERS: '/api/v1/telegram-companies/users',
    HIDE: '/api/v1/telegram-companies/hide',
    UPDATE_PROTECTED_EMAILS: '/api/v1/telegram-companies',
    UPDATE_BOT_INFO: '/api/v1/telegram-companies'
  },
  TELEGRAM_GROUPS: {
    LIST: '/api/v1/telegram-groups'
  },
  TELEGRAM_PRODUCTIVITY_REPORT: {
    BY_STAFF_DAILY: '/api/v1/telegram-productivity-report/by-staff-daily',
    BY_STAFF_DETAIL: '/api/v1/telegram-productivity-report/by-staff-detail',
    CUSTOMER_MESSAGES_BY_HOUR: '/api/v1/telegram-productivity-report/customer-messages-by-hour'
  },
  TELEGRAM_MESSAGES: {
    LIST: '/api/v1/telegram-messages'
  },
  TAG_GROUPS: {
    LIST: '/api/v1/tag-groups',
    CREATE: '/api/v1/tag-groups',
    UPDATE: '/api/v1/tag-groups',
    DELETE: '/api/v1/tag-groups'
  },
  TAGS: {
    LIST: '/api/v1/tags',
    DETAIL: '/api/v1/tags',
    CREATE: '/api/v1/tags',
    UPDATE: '/api/v1/tags',
    DELETE: '/api/v1/tags',
    PREVIEW_CONDITIONS: '/api/v1/tags/preview-conditions',
    PREVIEW: '/api/v1/tags',
    UPDATE_AD_ACCOUNT_TAGS: '/api/v1/tags/ad-account',
    UPDATE_CAMPAIGN_TAGS: '/api/v1/tags/campaign',
    UPDATE_ADSET_TAGS: '/api/v1/tags/adset',
    UPDATE_AD_TAGS: '/api/v1/tags/ad'
  },
  CAMPAIGNS: {
    LIST: '/api/v1/campaigns',
    EXPORT: '/api/v1/campaigns/export',
    ACCOUNTS: '/api/v1/accounts-advertising',
    TOGGLE_STATUS: '/api/v1/campaigns/toggle-status'
  },
  AD_SETS: {
    LIST: '/api/v1/ad-sets',
    EXPORT: '/api/v1/ad-sets/export',
    TOGGLE_STATUS: '/api/v1/ad-sets/toggle-status'
  },
  ADS: {
    LIST: '/api/v1/ads',
    EXPORT: '/api/v1/ads/export',
    TOGGLE_STATUS: '/api/v1/ads/toggle-status'
  },
  POSTS: {
    LIST: '/api/v1/posts',
    EXPORT: '/api/v1/posts/export'
  },
  META_INVOICES: {
    LIST: '/api/meta-invoices',
    EXPORT: '/api/meta-invoices/export'
  },
  FACEBOOK_ADS_EMAILS: {
    LIST: '/api/v1/facebook-ads-emails',
    EXPORT: '/api/v1/facebook-ads-emails/export'
  },
  BANK_INVOICES: {
    LIST: '/api/v1/bank-invoices',
    EXPORT: '/api/v1/bank-invoices/export'
  },
  BANK_BALANCES: {
    LIST: '/api/bank-balances',
    EXPORT: '/api/bank-balances/export',
    IMPORT: '/api/v1/bank-balances/import'
  },
    RENTAL: {
    GROUPS: '/api/v1/rental/groups',
    GROUPS_FILTERS: '/api/v1/rental/groups/filters',
    GROUPS_EXPORT: '/api/v1/rental/groups/export',
    STAFF: '/api/v1/rental/staff',
    STAFF_FILTERS: '/api/v1/rental/staff/filters',
    STAFF_EXPORT: '/api/v1/rental/staff/export',
    CUSTOMERS: '/api/v1/rental/customers',
    CUSTOMERS_EXPORT: '/api/v1/rental/customers/export',
    CUSTOMERS_NOTE: '/api/v1/rental/customers/note',
    AD_ACCOUNTS: '/api/v1/rental/ad-accounts',
    AD_ACCOUNTS_AVAILABLE: '/api/v1/rental/ad-accounts/available',
    RENT: '/api/v1/rental/rent',
    AD_ACCOUNTS_FILTERS: '/api/rental/ad-accounts/filters',
    AD_ACCOUNTS_PREVIEW: '/api/rental/ad-accounts/preview',
    AD_ACCOUNTS_ASSIGN: '/api/rental/ad-accounts/assign',
    AD_ACCOUNTS_EXPORT: '/api/v1/rental/ad-accounts/export',
    AD_ACCOUNTS_SETTLE: '/api/v1/rental/ad-accounts'
  },

  CUSTOMER_TRANSACTIONS: {
    TOPUP: '/api/v1/customer-transactions/topup',
    LIST: '/api/v1/customer-transactions',
    FILTER_OPTIONS: '/api/v1/customer-transactions/filter-options'
  },
  ACTION_HISTORY: {
    LIST: '/api/v1/action-history',
    DROPDOWN_OPTIONS: '/api/v1/action-history/dropdown-options'
  },
  CEO_DASHBOARD: {
    STATS: '/api/ceo-dashboard/stats',
    TREND: '/api/ceo-dashboard/trend',
    SECURITY_RISKS: '/api/ceo-dashboard/security-risks',
    TIMEZONES: '/api/ceo-dashboard/timezones',
    CURRENCIES: '/api/ceo-dashboard/currencies',
    ACCOUNTS: '/api/ceo-dashboard/accounts'
  },
  BUSINESS_MANAGERS: {
    LIST: '/api/v1/business-managers',
    EXPORT: '/api/v1/business-managers/export',
    HIDE: '/api/v1/business-managers/hide'
  },
  FANPAGE: {
    LIST: '/api/v1/fanpages',
    SUMMARY: '/api/v1/fanpages/summary',
    EXPORT: '/api/v1/fanpages/export',
    REFRESH: '/api/v1/fanpages/refresh',
    TRASH: '/api/v1/fanpages/trash',
    BLACKLIST: '/api/v1/fanpages/blacklist',
    UPDATE_TAGS: (pageId) => `/api/v1/fanpages/${pageId}/tags`
  },
  SYSTEM_SETTINGS: {
    MISSING_ACCOUNTS: '/api/system-settings/missing_accounts'
  },
  SHIELD_CONFIGS: {
    LIST: '/api/v1/shield-configs',
    STORE: '/api/v1/shield-configs',
    VIOLATIONS: '/api/v1/shield-violations',
    UPDATE: (id) => `/api/v1/shield-configs/${id}`,
    ADD_WEBSITES: (id) => `/api/v1/shield-configs/${id}/websites`,
    DELETE_WEBSITES: (id) => `/api/v1/shield-configs/${id}/websites`,
    WEBSITES: (id) => `/api/v1/shield-configs/${id}/websites`
  },
  FANPAGES: {
    LIST: '/api/v1/fanpages',
    LIST_FOR_SELECT: '/api/v1/fanpages/list-for-select'
  },
  ADMIN: {
    RUN_COMMAND: '/api/v1/admin/run-command'
  },
  CARD_GROUPS: {
    LIST: '/api/v1/card-groups',
    CREATE: '/api/v1/card-groups',
    DELETE: (id) => `/api/v1/card-groups/${id}`,
    ADD_CARDS: (id) => `/api/v1/card-groups/${id}/cards`,
    CARDS: (id) => `/api/v1/card-groups/${id}/cards`,
    AVAILABLE_CARDS: (id) => `/api/v1/card-groups/${id}/available-cards`,
    CUSTOMERS_LIST: '/api/v1/card-groups/customers-list',
    CARDS_LIST: '/api/v1/card-groups/cards-list',
    IMPORT: '/api/v1/card-groups/import',
    EXPORT: '/api/v1/card-groups/export',
    EXPORT_CARDS: (id) => `/api/v1/card-groups/${id}/cards/export`
  }
}

// Permission constants
export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view-dashboard',
  VIEW_AD_ACCOUNTS: 'view-ad-accounts',
  VIEW_VIA_FACEBOOK: 'view-via-facebook',
  VIEW_BILLING: 'view-billing',
  VIEW_CAMPAIGNS: 'view-campaigns',
  VIEW_USERS: 'view-users',
  VIEW_ROLES: 'view-roles',
  VIEW_BANK: 'view-bank',
  VIEW_TELEGRAM: 'view-telegram',
  VIEW_RENTAL: 'view-rental',
  VIEW_BANK_INVOICES: 'view-bank-invoices',
  VIEW_PAYMENT_INVOICES: 'view-payment-invoices',
  VIEW_FINANCIAL_DASHBOARD: 'view-financial-dashboard',
  RUN_ADMIN_COMMANDS: 'run-admin-commands'
}

// Status constants
export const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
  PENDING: 2,
  SUSPENDED: 3
}

export const ACCOUNT_STATUS = {
  [STATUS.ACTIVE]: { label: 'Active', color: 'green' },
  [STATUS.INACTIVE]: { label: 'Inactive', color: 'red' },
  [STATUS.PENDING]: { label: 'Pending', color: 'yellow' },
  [STATUS.SUSPENDED]: { label: 'Suspended', color: 'gray' }
}

// Pagination constants
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  MAX_PAGE_SIZE: 200
}

// Date formats
export const DATE_FORMATS = {
  SHORT: 'dd/MM/yyyy',
  LONG: 'dd/MM/yyyy HH:mm:ss',
  ISO: 'yyyy-MM-dd',
  TIME: 'HH:mm:ss'
}

// File types
export const FILE_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv',
  PDF: 'application/pdf',
  IMAGE: 'image/*'
}

// Auto refresh intervals (in milliseconds)
export const AUTO_REFRESH_INTERVALS = {
  DISABLED: 0,
  FAST: 10000,      // 10 seconds
  NORMAL: 30000,    // 30 seconds
  SLOW: 60000,      // 1 minute
  VERY_SLOW: 300000 // 5 minutes
}

// Notification types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
}

// Theme colors (matching Tailwind config)
export const COLORS = {
  PRIMARY: {
    50: '#f0fdf4',
    500: '#10b981',
    600: '#059669',
    700: '#047857'
  },
  GRAY: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  }
}

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
  AUTO_REFRESH_ENABLED: 'autoRefreshEnabled',
  AUTO_REFRESH_INTERVAL: 'autoRefreshInterval',
  TABLE_PAGE_SIZE: 'tablePageSize',
  THEME: 'theme'
}

// Regex patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^(0|\+84)[0-9]{9,10}$/,
  FACEBOOK_ID: /^[0-9]+$/,
  URL: /^https?:\/\/.+/
}

// Error messages
export const ERROR_MESSAGES = {
  NETWORK: 'Network error. Please check your internet connection.',
  UNAUTHORIZED: 'Your session has expired. Please sign in again.',
  FORBIDDEN: 'You do not have permission to perform this action.',
  NOT_FOUND: 'The requested data could not be found.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION: 'Invalid data. Please check your input.',
  GENERIC: 'Something went wrong. Please try again later.'
}

// Success messages
export const SUCCESS_MESSAGES = {
  LOGIN: 'Signed in successfully.',
  LOGOUT: 'Signed out successfully.',
  SAVE: 'Data saved successfully.',
  DELETE: 'Data deleted successfully.',
  UPDATE: 'Data updated successfully.',
  EXPORT: 'Export completed successfully.',
  COPY: 'Copied to clipboard.'
}
